/**
 * The body of a response, whether or not it came wrapped in `{ value }`.
 *
 * WHY BOTH SHAPES, MEASURED ON develop. apps/api/src/app/swagger.ts declares
 * an envelope `{ error, value }` for every route it decorates: 227 of them,
 * across 41 controllers, which is why the generated client holds 201
 * envelope-shaped response models.
 *
 * The controllers do not agree with it. 177 return `result.value`, the payload
 * on its own, and the envelope in their generated type is wrong. 16 return the
 * Either object itself while declaring the payload's type, so for those the
 * envelope is right and the method signature is what lies. listShareableGroups
 * is one of the 16.
 *
 * Nothing unwraps anything between the two: this application runs a token
 * interceptor and no response interceptor. So whichever shape a route sends is
 * the shape that arrives, and a caller cannot know which without looking at
 * that route's controller.
 *
 * That is why call sites carry `res?.value ?? res` behind an assertion. The
 * assertion was a bumper against a real inconsistency, not laziness. This is
 * that same test, named once. Making the 227 routes agree is its own work.
 *
 * It moved here from the payments domain, where it was first written, because
 * it turned out not to be about payments.
 */
/** A response that may or may not carry its payload under `value`. */
export type Enveloped<T> = { error?: unknown; value?: T };

export const theBodyOf = <T>(response: unknown): T | undefined => {
  if (response === null || response === undefined) {
    return undefined;
  }
  const wrapped = (response as { value?: unknown }).value;
  return (wrapped === undefined ? response : wrapped) as T;
};
